import { useTranslation } from "react-i18next";

import { OperatorSubStateKind } from "../../types/Operator";
import { RootStateKind, useRootAndSubState } from "../state/StateProvider";

export const SystemInformation = () => {
    const { state } = useRootAndSubState(
        RootStateKind.Operator,
        OperatorSubStateKind.SystemInformation
    );
    const { systemInformation } = state;
    const { t } = useTranslation();

    return (
        <div className="m-4 flex h-full flex-col gap-4 overflow-y-scroll pb-16">
            <div className="text-3xl font-semibold text-primary-900">
                {t("operator.systemInformation.title")}
            </div>
            <div className="flex flex-col">
                <div className="font-medium">
                    {t("operator.systemInformation.deviceId")}
                </div>
                <div className="italic">{systemInformation.deviceId}</div>
            </div>
            <div className="flex flex-col">
                <div className="font-medium">
                    {t("operator.systemInformation.cashRegisterId")}
                </div>
                <div className="italic">{systemInformation.cashRegisterId}</div>
            </div>
            <div className="flex flex-col">
                <div className="font-medium">
                    {t("operator.systemInformation.paymentDeviceId")}
                </div>
                <div className="italic">
                    {systemInformation.paymentDeviceId}
                </div>
            </div>
            <div className="flex flex-col">
                <div className="font-medium">
                    {t("operator.systemInformation.paymentDeviceIp")}
                </div>
                <div className="italic">
                    {systemInformation.paymentDeviceIp || t("unknown")}
                </div>
            </div>
            <div className="flex flex-col">
                <div className="font-medium">
                    {t("operator.systemInformation.runningVersion")}
                </div>
                <div className="italic">{systemInformation.runningVersion}</div>
            </div>
            <div className="flex flex-col">
                <div className="font-medium">
                    {t("operator.systemInformation.storeId")}
                </div>
                <div className="italic">{systemInformation.storeId}</div>
            </div>
            <div className="flex flex-col">
                <div className="font-medium">
                    {t("operator.systemInformation.productPresetIds")}
                </div>
                <div className="italic">
                    {systemInformation.productPresetIds.join(", ")}
                </div>
            </div>
            <div className="flex flex-col">
                <div className="font-medium">
                    {t("operator.systemInformation.kitchenMenuId")}
                </div>
                <div className="italic">
                    {systemInformation.kitchenMenuId || t("unknown")}
                </div>
            </div>
            <div className="flex flex-col">
                <div className="font-medium">
                    {t("operator.systemInformation.tenant")}
                </div>
                <div className="italic">{systemInformation.tenant}</div>
            </div>
        </div>
    );
};
